<div class="login-form" [class.login-form--boxed]="showBorder">
  <div class="login-form__step" [formGroup]="loginForm" *ngIf="!show2FA">
    <p class="field-error" id="login-failed-error" *ngIf="isLoginFailed">
      {{ "loginForm.wrongCredentials" | translate }}
    </p>

    <p class="field-error" *ngIf="!isUserVerified">
      {{ "loginForm.userNotVerifiedError" | translate }}
    </p>

    <div class="form-field">
      <label for="login-username">{{ "loginForm.login" | translate }}</label>

      <div class="input-wrapper">
        <lucide-icon name="user" [size]="19"></lucide-icon>
        <input id="login-username" formControlName="login" autocomplete="username" />
      </div>
    </div>

    <div class="form-field">
      <label for="login-password">{{ "password.label" | translate }}</label>

      <div class="input-wrapper">
        <lucide-icon name="lock" [size]="19"></lucide-icon>
        <input
          id="login-password"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          autocomplete="current-password"
          (keyup.enter)="onEnterkeyPress('password')"
        />

        <button
          type="button"
          class="visibility-button"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="showPassword ? ('password.hide' | translate) : ('password.show' | translate)"
        >
          <lucide-icon [name]="showPassword ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="login-form__step login-form__step--otp" [formGroup]="digits2FAForm" *ngIf="show2FA">
    <div class="otp-header">
      <h2 id="login-2fa-title">{{ "loginForm.2fa.title" | translate }}</h2>
      <p>{{ "loginForm.2fa.text" | translate }}</p>
    </div>

    <p class="field-error" id="login-2fa-failed-error" *ngIf="is2FAFailed">
      {{ "loginForm.2fa.wrongCode" | translate }}
    </p>

    <div class="otp-fields" formArrayName="digits">
      <input
        *ngFor="let d of digitsFormArray.controls; let i = index"
        [formControlName]="i"
        maxlength="1"
        placeholder="-"
        class="otp-input"
        [id]="'digitInput' + i"
        autocomplete="one-time-code"
        (keypress)="preventCharacter($event, [PREVENT_CHARACTER.SPECIAL_CHAR, PREVENT_CHARACTER.LETTER], d)"
        (keydown)="onKeyDown($event, i)"
        (keyup.enter)="onEnterkeyPress(i)"
        (paste)="pasteEvent($event, i)"
      />
    </div>
  </div>

  <div class="form-actions">
    <button type="button" class="secondary-button" (click)="goBack()" *ngIf="show2FA">
      {{ "button.back" | translate }}
    </button>

    <button
      type="button"
      class="primary-button"
      id="login-button"
      [disabled]="(!show2FA && loginForm.disabled) || (show2FA && digits2FAForm.disabled)"
      (click)="onSubmit()"
    >
      {{ "button.login" | translate }}
    </button>
  </div>

  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <a *ngIf="!show2FA" class="text-link" (click)="goToResetPassword()" tabindex="0">
    {{ "loginForm.resetPassword" | translate }}
  </a>

  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <a *ngIf="show2FA" class="text-link" (click)="onSubmit(true)" tabindex="0">
    {{ "loginForm.2fa.resendCode" | translate }}
  </a>

  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <a *ngIf="show2FA" class="text-link" tabindex="0" (click)="showTelecoms = !showTelecoms">
    {{ "loginForm.2fa.emailNotAccess" | translate }}
  </a>

  <div class="telecom-list" *ngIf="showTelecoms">
    <label class="telecom-option" *ngFor="let telecom of telecoms">
      <input type="radio" name="telecom" [value]="telecom" [(ngModel)]="telecomToSend" [ngModelOptions]="{ standalone: true }" />
      {{ telecom.value }}
    </label>

    <button type="button" class="primary-button" (click)="onSubmit(true, true)">
      {{ "button.resend" | translate }}
    </button>
  </div>
</div>
